<div class="text-center user-info" [ngClass]="{'minified':expanded}" (click)="goToDetail()">
  <img *ngIf="user.userProfilePhotoPath; else noPhoto" class="rounded-circle" [attr.src]="user.userProfilePhotoPath + '?thumbnail=true'" />
  <ng-template #noPhoto>
    <i class="no-user-icon fas fa-user text-muted border rounded-circle"></i>
  </ng-template>
  <p class="small name">{{user.fullName}}</p>
  <p class="small text-uppercase title">{{user.title}}</p>
</div>
